import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";

export default function AdminStudents() {
  const [rows, setRows] = useState([]);
  const load = async () => { const { data } = await api.get("/admin/students"); setRows(data); };
  useEffect(() => { load(); }, []);
  const setPlan = async (uid, plan) => { await api.patch(`/admin/users/${uid}`, { plan }); toast.success("Güncellendi"); load(); };
  return (
    <div className="space-y-4">
      <h1 className="font-display text-3xl tracking-tight">Öğrenciler</h1>
      <div className="border border-[#262626] rounded-lg overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#171717] text-slate-400 text-xs uppercase">
            <tr><th className="text-left p-3">Ad</th><th className="text-left p-3">E-posta</th><th className="text-left p-3">Rol</th><th className="text-left p-3">Plan</th></tr>
          </thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.user_id} className="border-t border-[#262626]">
                <td className="p-3">{u.name}</td>
                <td className="p-3 text-slate-300">{u.email}</td>
                <td className="p-3">{u.role}</td>
                <td className="p-3">
                  <select value={u.plan} onChange={(e) => setPlan(u.user_id, e.target.value)}
                    className="px-2 py-1 rounded bg-[#0A0A0A] border border-[#262626]">
                    <option value="free">Ücretsiz</option>
                    <option value="premium">Premium</option>
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
